import { UPDATE_PASSWORD, UPDATE_PASSWORD_SUCCESSFUL, UPDATE_PASSWORD_FAILED } from "./actionTypes"

const initialState = {
    successMessage: null,
    errorMessage: null,
    loader: false,
    updatePasswordObject: null
}

const updatePasswordReducer = (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_PASSWORD:
            state = {
                ...state,
                loader: true,
                errorMessage:null,
                successMessage:null,
                updatePasswordObject: action.payload
            }
            break
        case UPDATE_PASSWORD_SUCCESSFUL:
            state = {
                ...state,
                loader: false,
                errorMessage:null,
                successMessage:action.payload,
                updatePasswordObject: null
            }
            break;
        case UPDATE_PASSWORD_FAILED:
            state = {
                ...state,
                loader : false,
                errorMessage : action.payload,
                successMessage : null,
                updatePasswordObject : null
            }
            break
        default:
            state = { ...state }
            break
    }
    return state
}

export default updatePasswordReducer
